// webrtcdatachannel
import { ErrorLogger } from "@/utils/module_api";

let pc: any;
let dc: any;
let eventSource: any;
let b64Offer: any;
let md5offer: any;
let side: "offer" | "answer";

// Signaling server configuration
const SIGNALING_SERVER = "https://signalling.switch168.org";

// WebRTC configuration
const iceServers = [
  { urls: "stun:stun.l.google.com:19302" },
  { urls: "stun:stun1.l.google.com:19302" },
  { urls: "stun:stun2.l.google.com:19302" },
  { urls: "stun:stun3.l.google.com:19302" },
  { urls: "stun:stun4.l.google.com:19302" },
];

export default {
  init(options: { registerExtraDevicePublicKey?: any; getNewToken?: any }) {
    pc = new (window as any).RTCPeerConnection({ iceServers });
    pc.ondatachannel = (event: RTCDataChannelEvent) => {
      console.log("Data channel event:", event);
      dc = event.channel;
      dc.onopen = () => {
        console.log("Data channel is open");
        dc.send(" hello again");
      };
      dc.onclose = () => {
        console.log("Data channel is closed");
      };
      dc.onerror = (error: any) => {
        console.error("Data channel error:", error);
      };
      dc.onmessage = async (event: MessageEvent) => {
        try {
          if (side === "answer") {
            console.log("received key:", event.data);
            const { publicKey } = JSON.parse(event.data);
            const { token } = await options.registerExtraDevicePublicKey({
              publicKey,
            });

            console.log("token", token);
            dc.send(JSON.stringify({ token }));

            await options.getNewToken();
            // PHONE register the key
          }
        } catch (error) {
          ErrorLogger.logError(error, "wdc.ts");
          console.error("Error parsing message:", error);
        }
      };
    };
  },

  createOffer({
    publicKey,
    linkedDeviceOnReceiveToken,
  }: {
    publicKey: string;
    linkedDeviceOnReceiveToken: any;
  }): Promise<string> {
    return new Promise((resolve) => {
      try {
        dc = pc.createDataChannel("desktopLink", {
          ordered: true,
          negotiated: false,
          id: 0,
        });

        dc.onopen = () => {
          setTimeout(() => {
            console.log("Data channel is open");
            if (side === "offer") {
              console.log("offerer is sending public key");
              dc.send(JSON.stringify({ publicKey }));
            }
            if (side === "answer") {
              console.log("send answer");
              dc.send("answer");
            }
          }, 1000);
        };
        dc.onclose = () => {
          console.log("Data channel is closed");
        };
        dc.onerror = (error: any) => {
          console.error("Data channel error:", error);
        };
        dc.onmessage = async (event: MessageEvent) => {
          try {
            if (side === "offer") {
              const { token } = JSON.parse(event.data);
              await linkedDeviceOnReceiveToken({ token });
            }
            console.log("Received message:", event.data);
            // DESKTOP received event here
            // Handle incoming messages here
          } catch (error) {
            ErrorLogger.logError(error, "wdc.ts");
            console.error("Error parsing message:", error);
          }
        };
        let iceTimer: ReturnType<typeof setTimeout> | null = null;

        pc.onicecandidate = (e: any) => {
          console.log("onicecandidate", e);
          // Start timer on first candidate
          if (!iceTimer) {
            iceTimer = setTimeout(() => {
              const fullSDP = pc.localDescription?.sdp;
              if (fullSDP) {
                b64Offer = btoa(fullSDP);
                console.log({ fullSDP });
                console.log("Captured SDP after 2 seconds:", b64Offer);
                // You can send or store b64Offer here
              }
            }, 800); // 2 seconds
          }
        };
        side = "offer";
        pc.createOffer()
          .then(async (offer: any) => {
            console.log({ offer });
            pc.setLocalDescription(offer);
            setTimeout(() => {
              md5offer = base64ToMD5(b64Offer);
              resolve(b64Offer);
            }, 1000);
          })
          .catch((error: any) => {
            console.error("Error creating offer:", error);
          });
      } catch (error) {
        ErrorLogger.logError(error, "wdc.ts");
        console.error(error);
      }
    });
  },
  async createAnswer(b64offer: string): Promise<string> {
    side = "answer";
    console.log("createAnswer");
    md5offer = base64ToMD5(b64offer);
    const decodedOffer = atob(b64offer);
    console.log("Decoded offer:", decodedOffer);
    const sdp = new (window as any).RTCSessionDescription({
      type: "offer",
      sdp: decodedOffer,
    });
    console.log("SDP:", sdp);
    await pc.setRemoteDescription(sdp);
    const answer = await pc.createAnswer();
    await pc.setLocalDescription(answer);
    return btoa(answer.sdp);
  },
  async createSignallingSession(): Promise<string> {
    const response = await fetch(`${SIGNALING_SERVER}/session`);
    const data = await response.json();
    const sessionUuid = data.uuid;
    return sessionUuid;
  },
  startSocket() {
    console.log("startSocket", md5offer);
    if (eventSource) {
      eventSource.close();
    }
    eventSource = new EventSource(`${SIGNALING_SERVER}/offer/${md5offer}`);
    eventSource.onmessage = (event: MessageEvent) => {
      console.log("Received message:", event.data);
      const b64answer = JSON.parse(event.data);
      // decode base64 to json object
      const decodedAnswer = atob(b64answer);
      console.log({ decodedAnswer });
      const answer = decodedAnswer;
      if (answer) {
        console.log("Received answer:", answer);
        const sdp = new (window as any).RTCSessionDescription({
          type: "answer",
          sdp: answer,
        });
        pc.setRemoteDescription(sdp);
      }
    };
  },
  async sendAnswer(b64Answer: string) {
    console.log("sendAnswer", b64Answer);
    if (!md5offer) {
      console.error("fatal MD5 offer is not set");
      return;
    }
    const response = await fetch(`${SIGNALING_SERVER}/answer/${md5offer}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        b64Answer,
      }),
    });
    console.log("sendAnswer response:", response);
  },
  clean() {
    if (eventSource) {
      eventSource.close();
      eventSource = null;
    }
    if (dc) {
      try {
        dc.close();
      } catch (error) {
        console.warn("Failed to close data channel", error);
      }
      dc = null;
    }
    if (pc) {
      try {
        pc.close();
      } catch (error) {
        console.warn("Failed to close peer connection", error);
      }
      pc = null;
    }
  },
};
function base64ToMD5(base64: string): string {
  console.log({ base64 });
  const binary = atob(base64);
  // @ts-ignore
  const md5 = SparkMD5.hash(binary);
  console.log("MD5 hash:", md5);
  return md5;
}
